import searchService from '../../services/search.service'

export const autocompleteCompany = {
  data() {
    return {
      searchCompanies: [],
      searchResultsNumber: 20,
    }
  },
  methods: {
    autocompleteCompany: _.debounce(function(v) {
      const vm = this
      searchService.getQuicksearchByKind(v, 'company').then(res => {
        vm.searchCompanies = res.data.data.slice(0, vm.searchResultsNumber)
      })
    }, 300),
  },
}
